<script>
    import {M} from "../external";

    let data = {};

    export function get() {
        return data;
    }

    $: {
        if (!data.name) data.name = '';
        if (!data.email) data.email = '';
    }
</script>
<div>
    <div class="popup-input-wrapper">
        <h5>{M.NAME}</h5>
        <input type="text" name="name" bind:value={data.name} placeholder="{M.NAME}" class="focus transition-border">
    </div>
    <div class="popup-input-wrapper">
        <div class="info">
            <h5>{M.EMAIL}</h5>
        </div>
        <input type="text" name="email" bind:value={data.email} placeholder="{M.EMAIL}" class="transition-border">
    </div>
</div>